import React, { useEffect, useRef, useState } from "react";
import { Table, Tooltip, Col, Input, Row, Image, Button } from "antd";
import HeadingBack from "./common/HeadingBack";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import SvgIcon from "./const/SvgIcon";
import { allApiAction } from "../Redux/common/action";

import { ExclamationCircleFilled } from "@ant-design/icons";
import { Modal } from "antd";
import { toast } from "react-toastify";
import { URL } from "../Redux/common/url";
import { AsyncPaginate } from "react-select-async-paginate";
import moment from "moment";
import LoadOptions from "./common/LoadOptions";

import { CKEditor } from "ckeditor4-react";

const defaultObj = {
  occasion_id: "",
  name: "",
  description: "",
  image: "",
};

function OccasionFunctions() {
  const { confirm } = Modal;
  const dispatch = useDispatch();

  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");

  const [showDelelt, setShowDelete] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [filterOccasion, setFilterOccasion] = useState(null);
  const [functionDetails, setFunctionDetails] = useState({ ...defaultObj });

  const { functionList } = useSelector((state) => ({
    functionList: state?.allApi?.function_list || {},
    // cityList: state?.allApi?.city_list?.data || []
  }));
  const listData = functionList?.data ? functionList?.data : [];

  useEffect(() => {
    dispatch(allApiAction.getFunctions({ page: page, search: search, occasion_id: filterOccasion ? filterOccasion?.value : "" }));
  }, [search, page, filterOccasion]);

  const columns = [
    {
      width: "10%",
      key: "image",
      title: "Image",
      dataIndex: "image",
      render: (value, item, index) => {
        return (
          <>
            <div style={{ width: "50px" }}>
              <Image src={URL?.API_BASE_URL + item?.image}
                alt="N/A" />
            </div>
          </>
        );
      },
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Occasion",
      dataIndex: "occasion",
      key: "occasion",
      render: (value) => value.title
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      render: (text) => {
        return (
          <div
            dangerouslySetInnerHTML={{ __html: text }}
            style={{ wordBreak: "break-word" }}
          />
        );
      },
    },
    {
      title: "Created Date",
      dataIndex: "created_at",
      key: "created_at",
      render: (value) => moment(value).format("DD-MM-YYYY")
    },
    {
      title: "Actions",
      dataIndex: "action",
      key: "action",
      className: "table_action_col",
      render: (value, item, index) => {
        return (
          <>
            <Tooltip title="Edit">
              <span
                className="cursor-pointer"
                onClick={() => {
                  handleModal({
                    ...item, occasion_id: { value: item?.occasion?.id, label: item?.occasion?.title }
                  });
                }}
              >
                <SvgIcon.Edit className="scale-icon edit-icon" />
              </span>
            </Tooltip>
            <Tooltip title="Delete">
              <span
                className="cursor-pointer"
                onClick={() => {
                  showDeleteConfirm(item?.id);
                }}
              >
                <SvgIcon.deletebtn className="scale-icon edit-icon" />
              </span>
            </Tooltip>
          </>
        );
      },
    },
  ];

  const handleDelete = async (e) => {
    setShowDelete(false);
    await dispatch(allApiAction.deleteFunction({ id: e, page: page }));
    await dispatch(allApiAction.getFunctions({ page }));
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const files = event.target.files;
      setSelectedFile(files);
    }
  };

  const handleTextChange = (e) => {
    const { name, value } = e.target;
    setFunctionDetails((prev) => ({ ...prev, [name]: value }));
  };


  const showDeleteConfirm = (e) => {
    confirm({
      title: "Are you sure delete ?",
      icon: <ExclamationCircleFilled />,
      content: "Function",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        handleDelete(e);
      },
      onCancel() {
      },
    });
  };

  const handleModal = (editData) => {
    editData && editData !== undefined ? setFunctionDetails(editData) : setFunctionDetails({ ...defaultObj });
    setIsModalOpen(!isModalOpen);
  };

  const handleSearch = (e) => {
    setSearch(e);
  };

  const handlePageChange = (currentPage) => {
    setPage(currentPage);
  };

  const loadOptions = async (apiUrl, search, currOptions, { page }) => {
    const queryParams = new URLSearchParams({ page, search });

    const token = await localStorage.getItem("admin_token");
    const url = `${URL.API_BASE_URL}${apiUrl}?${queryParams.toString()}`;
    const response = await fetch(url,
      {
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    );
    const resJSON = await response.json();
    const res = resJSON?.data?.data;
    const options = res?.map((data) => ({ value: data?.id, label: data?.title }));

    const obj = {
      options: options,
      hasMore: resJSON?.data?.total > resJSON?.data?.to ? true : false,
      additional: {
        page: page + 1,
      },
    };
    return obj;
  };

  const checkValidation = () => {
    if (!functionDetails?.occasion_id) {
      toast.error("Please select occasion ");
      return false;
    } else if (!functionDetails?.name) {
      toast.error("Please enter a name");
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {

    if (!checkValidation()) {
      return;
    }

    const data = new FormData();
    data.append("name", functionDetails?.name);
    data.append("occasion_id", functionDetails?.occasion_id?.value);

    ["description"].map((key) => {
      if (functionDetails?.[key]) {
        data.append(key, functionDetails?.[key]);
      };
    });

    if (selectedFile) {
      for (let i = 0; i < selectedFile?.length; i++) {
        data.append("image", selectedFile[i]);
      }
    };
    try {
      if (functionDetails?.id) {
        data.append("id", functionDetails?.id);
        await dispatch(allApiAction.updateFunction(data));
      } else {
        await dispatch(allApiAction.addFunction(data));
      };
      setSelectedFile(null);
      dispatch(allApiAction.getFunctions({ page: 1 }));

      handleModal();
    } catch (error) {
      console.error("Error during API call:", error)
    };
  };

  return (
    <div>

      {/* Header Bar */}
      <div className="flex" >
        <div>
          <HeadingBack
            title={"Function"}
            subHeading={`Total ${functionList?.total || 0} Function`}
          />
        </div>
        <Col md={5} sm={5} lg={3} xs={12} className="ml-5 pl-5">
          <Input
            type="text"
            autoComplete="new-off"
            className="form-control"
            onChange={(e) => handleSearch(e.target.value)}
            placeholder="Search..."
            value={search}
          />
        </Col>
        <Col md={4} sm={4} lg={4} xs={12} className="ml-5">
          <AsyncPaginate
            // key={managerKeyJen}
            additional={{ page: 1, value: "id", label: "title" }}
            className="p-0"
            placeholder="Select Occasion"
            value={filterOccasion}
            loadOptions={(search, loaded, additional) => LoadOptions(URL.get_occasions, search, loaded, additional)}
            onChange={(value) => {
              setFilterOccasion(value)
            }}
          />
        </Col>

        {/* Filter control buttons */}
        <Col md={4} sm={4} xs={12} className="ml-5">
          {/* <Button
            type="primary"
          onClick={handleSubmitFilter}
          disabled={!dateRange.fromdate || !dateRange.todate}
          >
            Submit
          </Button> */}
          <Button
            className="ml-2"
            onClick={() => setFilterOccasion(null)}
            disabled={filterOccasion === null}
          >
            Reset
          </Button>
        </Col>
        <div className="flex flex1 align-items-center justify-content-end">
          <Tooltip title="Add">
            <span className="jop_btn" onClick={() => handleModal()}>
              Add
              <SvgIcon.Add width={40} height={40} className="cursor-pointer" />
            </span>
          </Tooltip>
        </div>
      </div>

      {/* Pagination Table */}
      <div className="tableResponsive mt-10">
        <Table
          dataSource={listData}
          columns={columns}
          className={"table antd_table"}
          pagination={{
            current: page,
            pageSize: 10,
            onChange(currentPage, pageSize) {
              handlePageChange(currentPage);
            },
            hideOnSinglePage: true,
            total: functionList?.total ? functionList?.total : 0,
          }}
        />
      </div>

      {/* Form Modal */}
      <Modal
        key={isModalOpen ? "Modal Open" : "Modal Close"}
        title="Function Modal"
        open={isModalOpen}
        onOk={handleSubmit}
        onCancel={() => setIsModalOpen(false)}
      >
        <Row gutter={[20, 20]} >

          <Col lg={12} md={12} sm={12} xs={12} >
            <label className="mb-2">Select Occasion : </label>
            <AsyncPaginate
              // key={managerKeyJen}
              additional={{ page: 1, }}
              value={functionDetails?.occasion_id}
              loadOptions={(search, loaded, obj) => loadOptions(URL.get_occasions, search, loaded, obj)}
              onChange={(value) => {
                handleTextChange({ target: { name: "occasion_id", value: value } })
              }}
            />
          </Col>
          <Col lg={12} md={12} sm={12} xs={12} >
            <label className="mb-2">Name : </label>
            <input
              autoComplete="off"
              className="form-control"
              placeholder="Enter Name"
              name="name"
              value={functionDetails?.name}
              onChange={handleTextChange}
            />
          </Col>
          <Col lg={12} md={12} sm={12} xs={12} >
            <label className="mb-2">Image : </label>
            <input
              type="file"
              // multiple
              accept="image/*"
              onChange={handleFileChange}
            />
          </Col>
          <Col lg={24} md={24} sm={24} xs={24} className="mt-10">
            <div className="mb-4">
              <label className="form-label">Description</label>
              <div className="quill-container" style={{ marginBottom: '50px' }}>
                <CKEditor
                  initData={functionDetails?.description}
                  config={{
                    extraPlugins: 'table',
                    removePlugins: 'elementspath',
                    resize_enabled: false,
                    toolbarGroups: [
                      { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
                      { name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align'] },
                      { name: 'insert' },
                      { name: 'styles' },
                      { name: 'colors' },
                      { name: 'links' },
                      { name: 'table' }
                    ],
                    // Optional: Configure table plugin defaults or allowed features
                    table_removeTableTag: false
                  }}
                  onChange={(event) => {
                    const data = event.editor.getData();
                    setFunctionDetails((prev) => ({ ...prev, description: data }));
                  }}
                />
              </div>
            </div>
          </Col>
        </Row>
      </Modal>

    </div>
  );
}

export default OccasionFunctions;
